import { HttpClient } from '@angular/common/http';
import { oneAssetApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AssetService = /** @class */ (function () {
    function AssetService(http) {
        this.http = http;
    }
    AssetService.prototype.getQuestionAsset = function (cusid, type) {
        var URL = oneAssetApi + '/UHNW/getQuestionAsset';
        var body = {
            customerid: cusid,
            type: type
        };
        return this.http.post(URL, body);
    };
    AssetService.prototype.getQuestionTypeKnowledge = function () {
        var URL = oneAssetApi + '/UHNW/getQuestionTypeKnowledge';
        return this.http.get(URL);
    };
    AssetService.prototype.saveUltraHNW = function (param) {
        var URL = oneAssetApi + '/UHNW/saveUltraHNW';
        var body = {
            customerid: param.customerid,
            type: param.type,
            QuestionId: param.QuestionId
        };
        return this.http.post(URL, body);
    };
    AssetService.prototype.getKnowledgeDetail = function (param) {
        var URL = oneAssetApi + '/UHNW/getKnowledgeDetail';
        var body = {
            Customerid: param.Customerid,
            KnowledgeId: param.KnowledgeId
        };
        return this.http.post(URL, body);
    };
    AssetService.prototype.getAssetDetail = function (cusid, type) {
        var URL = oneAssetApi + '/UHNW/getAssetDetail';
        var body = {
            customerid: cusid,
            type: type
        };
        return this.http.post(URL, body);
    };
    AssetService.prototype.getPopup = function () {
        var URL = oneAssetApi + '/info/popup?source=web';
        return this.http.get(URL);
    };
    AssetService.ngInjectableDef = i0.defineInjectable({ factory: function AssetService_Factory() { return new AssetService(i0.inject(i1.HttpClient)); }, token: AssetService, providedIn: "root" });
    return AssetService;
}());
export { AssetService };
